export default __webpack_public_path__ + "static/media/redPT.18cce8cb.png";